module.exports = __webpack_public_path__ + "assets/img/linie-vertikal.c9173089.svg";